import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faPhoneVolume, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import useScreenSize from "../../hooks/useScreenSize";

import Style from "./Footer.module.css";
import { useI18n } from "../../i18n/I18nContext";

const ContactsElement = ({ icon, href, text, ariaLabel, openNewTab }) => {
  return (
    <a
      href={href}
      target={openNewTab ? "_blank" : ""}
      rel="noreferrer"
      className={Style["contacts-element"]}
      aria-label={ariaLabel}
    >
      <FontAwesomeIcon icon={icon} size="lg" style={{ marginRight: "20px" }} />
      {text || <span>{text}</span>}
    </a>
  );
};

const FooterDesktop = ({ items, copy }) => {
  return (
    <footer className={Style.footer}>
      <div className={Style["footer__inner-container"]}>
        <div>
          {items.map((i) => {
            return (
              <ContactsElement
                key={i.text}
                icon={i.icon}
                text={i.text}
                href={i.href}
                openNewTab={i.openNewTab}
              />
            );
          })}
        </div>
        <div>
          <nav>
            <Link to="/">{copy.navigation.home}</Link> &nbsp;|&nbsp;
            <Link to="/services">{copy.navigation.services}</Link> &nbsp;|&nbsp;
            <Link to="/technologies">{copy.navigation.technologies}</Link>{" "}
            &nbsp;|&nbsp;
            <Link to="/about-us">{copy.navigation.aboutUs}</Link>
            &nbsp;|&nbsp;<Link to="/wecp">Warenex e-commerce</Link>
            &nbsp;|&nbsp;
            <Link to="/contact-us">{copy.navigation.contactUs}</Link>
          </nav>
          <img
            className={Style.logo}
            src="logo-white-with-name.png"
            alt={copy.common.logoAlt}
          />
          <span> &#169; Warenex Ltd {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>
  );
};

const FooterMobile = ({ items, copy }) => {
  return (
    <footer className={Style.footer}>
      <nav className={Style["mobile-navigation"]}>
        <img
          className={Style.logo}
          src="logo-white-with-name.png"
          alt={copy.common.logoAlt}
        />
        <Link to="/">{copy.navigation.home}</Link>
        <Link to="/services">{copy.navigation.services}</Link>
        <Link to="/technologies">{copy.navigation.technologies}</Link>
        <Link to="/about-us">{copy.navigation.aboutUs}</Link>
        <Link to="/wecp">Warenex e-commerce</Link>
        <Link to="/contact-us">{copy.navigation.contactUs}</Link>
      </nav>
      <div className={Style["mobile-contacts"]}>
        {items.map((i) => {
          return (
            <ContactsElement
              key={i.text}
              icon={i.icon}
              href={i.href}
              ariaLabel={i.text}
              openNewTab={i.openNewTab}
            />
          );
        })}
        <span> &#169; Warenex Ltd {new Date().getFullYear()}</span>
      </div>
    </footer>
  );
};

const Footer = () => {
  const { isSmallSize, isMediumSize } = useScreenSize();
  const { copy } = useI18n();

  const isMobile = isSmallSize || isMediumSize;

  const contactElements = [
    {
      text: "https://www.facebook.com/warenexltd",
      href: "https://www.facebook.com/warenexltd",
      icon: faFacebook,
      openNewTab: true,
    },
    {
      text: "+359 87 731 0641",
      href: "tel:+359 87 731 0641",
      icon: faPhoneVolume,
    },
    {
      text: "contact@warenex.com",
      href: "mailto:contact@warenex.com",
      icon: faEnvelope,
    },
  ];

  return isMobile ? (
    <FooterMobile items={contactElements} copy={copy} />
  ) : (
    <FooterDesktop items={contactElements} copy={copy} />
  );
};

export default Footer;
